import React from "react";
import { Crown, Sparkles, ArrowRight } from "lucide-react";
import { SPEAKING_TOPICS } from "./speakingTopics";

export const SpeakingTopics = ({ onSelect }) => (
    <section className="mx-auto max-w-6xl px-6 md:px-10 pb-14" data-testid="speaking-topics-section">
        <div className="flex items-end justify-between gap-6 mb-6">
            <div>
                <div className="eyebrow text-gold-deep flex items-center gap-2">
                    <Sparkles className="w-3.5 h-3.5" /> Signature talks
                </div>
                <h2 className="mt-3 font-display text-3xl md:text-4xl">
                    Book a <em className="italic gold-text">message</em>, not just a speaker.
                </h2>
            </div>
            <p className="hidden md:block text-sm text-lilac-700 max-w-xs italic">
                Every talk can be shaped for your audience — keynote, workshop, or panel.
            </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {SPEAKING_TOPICS.map((t, i) => (
                <div
                    key={t.title}
                    data-testid={`speaking-topic-${i}`}
                    className="group flex flex-col rounded-3xl bg-white border border-lilac-200 hover:border-gold hover:-translate-y-1 hover:shadow-[0_24px_60px_rgba(43,29,53,0.12)] transition-all p-6"
                >
                    <div className="flex items-center justify-between">
                        <span className="grid place-items-center w-9 h-9 rounded-full bg-gold text-white">
                            <Crown className="w-4 h-4" />
                        </span>
                        <span className="text-[10px] uppercase tracking-[0.18em] text-gold-deep font-bold">
                            {t.tagline}
                        </span>
                    </div>
                    <h3 className="mt-4 font-display text-xl text-lilac-900 leading-snug">{t.title}</h3>
                    <p className="mt-2 text-sm text-lilac-700 leading-relaxed flex-1">{t.description}</p>
                    <button
                        type="button"
                        onClick={() => onSelect(t.title)}
                        data-testid={`speaking-topic-request-${i}`}
                        className="mt-5 inline-flex items-center gap-1.5 self-start text-xs font-bold uppercase tracking-[0.14em] text-lilac-900 group-hover:text-gold-deep transition-colors"
                    >
                        Request this talk <ArrowRight className="w-3.5 h-3.5" />
                    </button>
                </div>
            ))}
        </div>
    </section>
);
